import { call, select, takeLatest } from 'redux-saga/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import {
  BeibehaltungProduktRequestedPayload,
  GlobalAction,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '../appState';

export function* watchBeibehaltungProduktRequested() {
  yield takeLatest(
    GlobalActions.BEIBEHALTUNG_PRODUKT_REQUESTED,
    safeSaga(handleBeibehaltungProduktRequested, App.VHV_V2),
  );
}

export function* handleBeibehaltungProduktRequested(
  action: GlobalAction<BeibehaltungProduktRequestedPayload>,
) {
  const { angebotsId, vorbelegungdaten } = action.payload;
  const state: IAppState = yield select();
  if (vorbelegungdaten.forApp !== App.VHV_V2 || angebotsId !== state.angebotsId) {
    return;
  }
  const globalPut = GlobalPut.getInstance();
  const globalActions = new GlobalActions();

  yield call(
    [globalPut, globalPut.put],
    globalActions.produktRequested({
      appId: App.VHV_V2,
      angebotsId,
    }),
  );
}
